import './style.scss';

import React, { Component } from 'react';

import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import { Row, Col } from 'reactstrap';

class AdminPayments extends Component {
  render() {
    return (
      <PageWrap>
        <PageTitle
          breadcrumbs={{
            '/admin': 'Admin',
          }}
        >
          <Row className="mb-0">
            <Col lg="6">
              <h1>Pembayaran</h1>
            </Col>
          </Row>
        </PageTitle>
        <PageContent>
          <AsyncComponent component={() => import('./content')} />
        </PageContent>
      </PageWrap>
    );
  }
}

export default AdminPayments;
